import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

type LoaderElements = {
  spinnerContainer: SxProps
  spinnerBackground: SxProps
  spinner: SxProps
  spinnerThin: SxProps
}

/* const pulse = keyframes`
    0 %  { transform: rotate(-180deg) scale(1); },
    10%  { transform: rotate(0deg) scale(.8); },
    40%  { transform: rotate(0deg) scale(.8); },
    80%  { transform: rotate(180deg) scale(1); },
    100% { transform: rotate(180deg) scale(1); }
  ` */

export const loaderStyles = (transparent: boolean, fullscreen: boolean): LoaderElements => ({
  spinnerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    overflow: 'hidden',
    zIndex: 99999
  },
  spinnerBackground: {
    position: 'absolute',
    width: '100vw',
    height: '100vh',
    backgroundColor:
      transparent && fullscreen ? theme.colors.blackTransparency : theme.corporate.secondaryColor
  },
  spinner: {
    fontSize: '1rem'
  },
  spinnerThin: {
    fontSize: '0.5rem',
    marginBottom: '2px'
  }
})
